import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import Hamburger from 'hamburger-react';

import ASSETS from '../../assets';
// import Button from '../Button/Button';
import classNames from 'classnames';
import Button from '../Button/Button';

export const getMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return 'Android';
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  ) {
    return 'iOS';
  }
  return 'Other';
};

const Header = () => {
  const [open, setOpen] = useState(false);

  // const handleDownloadApp = () => {
  //   const os = getMobileOS();
  //   if (os === 'iOS') {
  //     window.location.href =
  //       'https://apps.apple.com/us/app/legal-avenue/id6474690584';
  //   } else {
  //     window.location.href =
  //       'https://play.google.com/store/apps/details?id=com.techconsultivo.legalavenue';
  //   }
  // };


  return (
    <>
      <div className='fixed w-full top-0 left-0 p-3 z-10'>
        <header className='md:h-[88px] h-[72px] flex items-center justify-between lg:px-[68px] md:px-12 px-5 bg-l-light-grey md:rounded-[24px] rounded-[12px] '>
          <Link to='/'>
            <img src={ASSETS.logo} className='lg:h-auto h-8' alt='' />
          </Link>
          <div className='items-center gap-[34px] flex max-[900px]:hidden'>
            <Link to='/about'>
              <p className='text-lg text-l-primary font-semibold uppercase'>
                About
              </p>
            </Link>
            {/* <Link to='/contact'>
              <p className='text-lg text-l-primary font-semibold uppercase'>
                Contact
              </p>
            </Link> */}
            {/* <p className='text-lg text-l-primary font-semibold uppercase'>
              news
            </p> */}
            <Link to='/FAQs'>
              <p className='text-lg text-l-primary font-semibold uppercase'>
                FAQs
              </p>
            </Link>
          </div>
          <a href='#footer'>
            <Button
              label='Download App'
              className='max-[900px]:!hidden'
              rightIcon={ASSETS.arrowRightWhite}
            />
          </a>
          <div className='min-[900px]:hidden'>
            <Hamburger size={24} toggle={setOpen} toggled={open} />
          </div>
        </header>
      </div>
      <div
        className={classNames(
          'fixed top-0  left-0 w-full p-3 transition-all duration-300',
          open ? 'translate-y-0' : 'translate-y-[-100%]'
        )}
      >
        <div className='mt-[62px] bg-l-light-grey shadow-sm rounded-b-[12px]'>
          <div
            className='items-center gap-4 flex flex-col pt-3 pb-5'
            onClick={() => setOpen(false)}
          >
            <Link to='/about'>
              <p className='text-lg text-l-primary font-semibold'>About</p>
            </Link>
            {/* <Link to='/contact'>
              <p className='text-lg text-l-primary font-semibold'>Contact</p>
            </Link> */}
            {/* <p className='text-lg text-l-primary font-semibold'>news</p> */}
            <Link to='/FAQs'>
              <p className='text-lg text-l-primary font-semibold'>FAQs</p>
            </Link>
            <a href='#footer'>
              <Button label='Download App' rightIcon={ASSETS.arrowRightWhite} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
